// extracted by mini-css-extract-plugin
module.exports = {"searchFormContainer":"SearchFormWrapper_searchFormContainer__i5XFs","emptyInput":"SearchFormWrapper_emptyInput__2uWkV","fullInput":"SearchFormWrapper_fullInput__C8Ga3"};